export interface ImportFieldDefinition {
  key: string;
  label: string;
  required: boolean;
  maxLength?: number;
  description?: string;
  synonyms: string[];
}

export const importFieldDefinitions: ImportFieldDefinition[] = [
  {
    key: 'memberNr',
    label: 'Medlemsnummer',
    required: true,
    maxLength: 12,
    description: 'Numeriskt, högst 12 siffror',
    synonyms: ['medlemsnr', 'medlemsnummer', 'member nr', 'member number', 'membernr', 'id', 'nr'],
  },
  {
    key: 'firstName',
    label: 'Förnamn',
    required: true,
    maxLength: 50,
    synonyms: ['förnamn', 'first name', 'firstname', 'förnamn', 'namn'],
  },
  {
    key: 'lastName',
    label: 'Efternamn',
    required: false,
    maxLength: 50,
    synonyms: ['efternamn', 'last name', 'lastname', 'surname', 'familjenamn'],
  },
  {
    key: 'COAddress',
    label: 'c/o',
    required: false,
    maxLength: 50,
    synonyms: ['c/o', 'co', 'coaddress', 'co-adress', 'c/o adress'],
  },
  {
    key: 'address',
    label: 'Adress',
    required: true,
    maxLength: 50,
    synonyms: ['adress', 'gatuadress', 'street', 'address', 'gata', 'boxadress'],
  },
  {
    key: 'zipcode',
    label: 'Postnummer',
    required: true,
    maxLength: 50,
    synonyms: ['postnr', 'postnummer', 'zip', 'zip code', 'zipcode', 'postal code', 'pnr'],
  },
  {
    key: 'city',
    label: 'Postort',
    required: true,
    maxLength: 50,
    synonyms: ['ort', 'stad', 'city', 'postort', 'postadress'],
  },
  {
    key: 'country',
    label: 'Land',
    required: false,
    maxLength: 50,
    synonyms: ['land', 'country', 'nation'],
  },
  {
    key: 'gender',
    label: 'Kön',
    required: false,
    maxLength: 50,
    synonyms: ['kön', 'gender', 'sex'],
  },
  {
    key: 'birthdate',
    label: 'Födelsedatum',
    required: false,
    maxLength: 50,
    synonyms: ['födelsedatum', 'birthdate', 'birth date', 'personnummer', 'pnr', 'födelseår', 'birthday', 'born'],
  },
  {
    key: 'phone',
    label: 'Telefon',
    required: false,
    maxLength: 50,
    synonyms: ['telefon', 'phone', 'tel', 'telefonnummer', 'phone number'],
  },
  {
    key: 'phoneOther',
    label: 'Telefon annan',
    required: false,
    maxLength: 50,
    synonyms: ['mobil', 'mobiltelefon', 'mobile', 'phone other', 'phoneother', 'telefon 2', 'tel2'],
  },
  {
    key: 'email',
    label: 'E-post',
    required: false,
    maxLength: 50,
    synonyms: ['e-post', 'epost', 'email', 'e-mail', 'mail', 'epostadress'],
  },
  {
    key: 'admissionDate',
    label: 'Inträdesdatum',
    required: true,
    maxLength: 50,
    description: 'YYYYMMDD',
    synonyms: ['inträdesdatum', 'admission date', 'admissiondate', 'inträde', 'anslutningsdatum', 'startdatum'],
  },
  {
    key: 'lastPayedDate',
    label: 'Senast betalat',
    required: false,
    maxLength: 50,
    description: 'YYYYMMDD',
    synonyms: ['senast betalat', 'betaldatum', 'last paid', 'lastpayeddate', 'betalat'],
  },
  {
    key: 'expireDate',
    label: 'Betalt t.o.m.',
    required: true,
    maxLength: 50,
    description: 'YYYYMMDD',
    synonyms: ['förfallodatum', 'expire date', 'expiredate', 'betalt tom', 'betalt t.o.m', 'avgift erlagd', 'giltig till'],
  },
  {
    key: 'comment',
    label: 'Kommentar',
    required: false,
    maxLength: 4000,
    synonyms: ['kommentar', 'comment', 'anteckning', 'notering'],
  },
  {
    key: 'note',
    label: 'Notering',
    required: false,
    maxLength: 4000,
    synonyms: ['notering', 'note', 'notes', 'intern kommentar'],
  },
  {
    key: 'custom1',
    label: 'Eget fält 1',
    required: false,
    maxLength: 50,
    synonyms: ['custom1', 'eget fält 1', 'extra 1', 'extrafält 1'],
  },
  {
    key: 'custom2',
    label: 'Eget fält 2',
    required: false,
    maxLength: 50,
    synonyms: ['custom2', 'eget fält 2', 'extra 2', 'extrafält 2'],
  },
  {
    key: 'custom3',
    label: 'Eget fält 3',
    required: false,
    maxLength: 50,
    synonyms: ['custom3', 'eget fält 3', 'extra 3', 'extrafält 3'],
  },
  {
    key: 'custom4',
    label: 'Eget fält 4',
    required: false,
    maxLength: 50,
    synonyms: ['custom4', 'eget fält 4', 'extra 4', 'extrafält 4'],
  },
  {
    key: 'custom5',
    label: 'Eget fält 5',
    required: false,
    maxLength: 50,
    synonyms: ['custom5', 'eget fält 5', 'extra 5', 'extrafält 5'],
  },
  {
    key: 'custom6',
    label: 'Eget fält 6',
    required: false,
    maxLength: 50,
    synonyms: ['custom6', 'eget fält 6', 'extra 6', 'extrafält 6'],
  },
  {
    key: 'custom7',
    label: 'Eget fält 7',
    required: false,
    maxLength: 50,
    synonyms: ['custom7', 'eget fält 7', 'extra 7', 'extrafält 7'],
  },
  {
    key: 'custom8',
    label: 'Eget fält 8',
    required: false,
    maxLength: 50,
    synonyms: ['custom8', 'eget fält 8', 'extra 8', 'extrafält 8'],
  },
  {
    key: 'custom9',
    label: 'Eget fält 9',
    required: false,
    maxLength: 50,
    synonyms: ['custom9', 'eget fält 9', 'extra 9', 'extrafält 9'],
  },
  {
    key: 'custom10',
    label: 'Eget fält 10',
    required: false,
    maxLength: 50,
    synonyms: ['custom10', 'eget fält 10', 'extra 10', 'extrafält 10'],
  },
  {
    key: 'newspaper',
    label: 'Tidning',
    required: false,
    synonyms: ['tidning', 'newspaper', 'news'],
  },
  {
    key: 'familyHeadNr',
    label: 'Familjeöverhuvud',
    required: false,
    synonyms: ['familjeöverhuvud', 'family head', 'familyheadnr', 'hushåll'],
  },
  {
    key: 'profiles',
    label: 'Profiler',
    required: false,
    description: 'Grupp|Profil, separerade med kommatecken',
    synonyms: [],
  },
];

/**
 * Försöker matcha en kolumnrubrik mot ett av våra fält.
 * Returnerar fältets key eller null om ingen matchning.
 */
export const guessFieldMapping = (header: string): string | null => {
  const normalized = header.trim().toLowerCase();

  // Exakt match på key
  const exactMatch = importFieldDefinitions.find((f) => f.key.toLowerCase() === normalized);
  if (exactMatch) return exactMatch.key;

  // Synonym match
  const synonymMatch = importFieldDefinitions.find((f) => f.synonyms.some((s) => s.toLowerCase() === normalized));
  if (synonymMatch) return synonymMatch.key;

  // Delvis match (kolumnnamnet innehåller synonym eller tvärtom)
  const partialMatch = importFieldDefinitions.find((f) =>
    f.synonyms.some((s) => normalized.includes(s.toLowerCase()) || s.toLowerCase().includes(normalized)),
  );
  if (partialMatch) return partialMatch.key;

  return null;
};
